import { reviewReduxConstants } from '@/constants';
import { Review, ReviewDetails, ReviewsSearchResult } from '@/types/reviews';

function setReviewListItems(
  uid: string,
  {
    ids,
    all,
    olderIds,
    newerIds,
  }: { ids: string[]; all: Record<string, Review>; olderIds: string[]; newerIds: string[] },
  concat?: boolean,
) {
  return { type: reviewReduxConstants.SET_REVIEW_LIST_ITEMS, payload: { uid, ids, all, olderIds, newerIds, concat } };
}

function setReviewDetails(uid: string, reviewDetails: ReviewDetails) {
  return { type: reviewReduxConstants.SET_REVIEW_DETAILS, payload: { uid, reviewDetails } };
}

function resetReviewsState(uid: string) {
  return { type: reviewReduxConstants.RESET_REVIEWS_STATE, payload: { uid } };
}

function setReviewsSearchResult(uid: string, searchResult: ReviewsSearchResult) {
  return { type: reviewReduxConstants.SET_REVIEWS_SEARCH_RESULT, payload: { uid, searchResult } };
}

export const reviewsActions = {
  setReviewListItems,
  setReviewDetails,
  setReviewsSearchResult,
  resetReviewsState,
};
